import { getRemotes } from './contract/api'

const getenvironment = async () => {
  const r = await getRemotes()

  // window.APPFRAME_URL = r.APPFRAME_URL
  window.STYLE_URL = r.STYLE_URL

  import('./bootstrap')
}

getenvironment()
